import React, { useState, useEffect } from 'react'
import Select from 'react-select';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import './style.css'
import ProfDashboardLayout from './ProfDashboardLayout'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import { professionalDeleteService, ProfessionalServicesAPI, ProfessionalServicesShowAPI, ProfessionalServiceUpdateAPI } from '../../../redux/slices/ProfessionalServcicesSlice';
import { services } from '../../../constants/base';

const ProfMyServices = () => {

    const dispatch = useDispatch();
    const today = new Date();
    const formattedDate = today.toLocaleDateString("en-US");
    const user = useSelector((state) => state?.AuthSlice?.user)
    const allServices = useSelector(state => state?.ProfessionalAddServicesSlice?.services)
    const loading = useSelector(state => state.ProfessionalAddServicesSlice.loading)
    const showLoading = useSelector(state => state.ProfessionalAddServicesSlice.showLoading)
    const deleteLoading = useSelector(state => state.ProfessionalAddServicesSlice.deleteLoading)

    useEffect(() => {
        if (user?.id) {
            dispatch(ProfessionalServicesShowAPI(user?.id));
        }
    }, [user?.id]);

    // ADD SERVICES
    const [isOpen, setIsOpen] = useState(false);
    const [deletedId, setDeletedId] = useState("")
    const [selectedCurrency, setSelectedCurrency] = useState("");
    const [priceOptions, setPriceOptions] = useState([15, 20, 30]);
    const [name, setSelectedService] = useState(null);
    const [formData, setFormData] = useState({
        name: "",
        currency: "USD",
        price: "",
        user_id: user?.id,
        corporate_id: user?.id
    });

    const [savedData, setSavedData] = useState([]);
    const isFormValid = formData.name && formData.price;

    const currencyOptions = [
        { label: "USD", symbol: "$" },
        { label: "Pound", symbol: "£" },
        { label: "PKR", symbol: "₨" },
    ];

    const handleCurrencyChange = (currency) => {
        setSelectedCurrency(currency);
        const currencyData = currencyOptions.find((item) => item.label === currency);
        if (currencyData) {
            setPriceOptions([15, 20, 30]);
            setFormData((prev) => ({
                ...prev,
                currency: currency,
                price: "",
            }));
        }
    };

    const handleSave = async (e) => {
        e.preventDefault();
        const res = await dispatch(ProfessionalServicesAPI(formData));
        if (res?.payload?.status === 200) {
            toast.success("Service Added Successfully")
            await dispatch(ProfessionalServicesShowAPI(user?.id));
            const closeButton = document.querySelector("#click-close-btn");
            if (closeButton) {
                closeButton.click();
            }
        } else {
            toast.error("something went wrong, try again")
        }
        // Reset formData state
        setFormData({
            user_id: user?.id,
            corporate_id: user?.id,
            name: "",
            currency: "USD",
            price: "",
        });
    };
    // ADD SERVICES
    // EDIT SERVICE MODEL
    const handleEditService = (itemId) => {
        const selectedItem = allServices.find((item) => item.id === itemId);
        if (selectedItem) {
            setFormData({
                ...selectedItem,
            });
            const modal = new window.bootstrap.Modal(document.getElementById('exampleModalToggle2'));
            modal.show();
        }
    };

    const handleUpdateServie = async (e) => {
        e.preventDefault();
        const res = await dispatch(ProfessionalServiceUpdateAPI(formData));
        const updateddata = await dispatch(ProfessionalServicesShowAPI(user?.id));
        const closeButton = document.querySelector("#close-btn-update-model");
        if (closeButton) {
            closeButton.click();
        }

        setFormData({
            user_id: user?.id,
            corporate_id: user?.id,
            name: "",
            currency: "USD",
            price: "",
        });
    }

    const handleDeleteService = async (id) => {
        await dispatch(professionalDeleteService(id))
        const response = await dispatch(ProfessionalServicesShowAPI(user?.id));
        setDeletedId("");
        const closeButton = document.querySelector("#close-btn-update-model-3");
        if (closeButton) {
            closeButton.click();
        }
    }


    const options = services?.map((item) => ({
        value: item.label,
        label: item.label,
    }));

    return (
        <>
            <ProfDashboardLayout>
                <div className="container p-0">
                    <div className="row">
                        <div className="col-md-12 justify-content-end d-flex">
                            <span className='add-services-button' data-bs-toggle="modal" href="#exampleModalToggle" role="button">Add Services <i className="fa-solid fa-plus"></i></span>
                        </div>

                        {Array.isArray(allServices) && allServices?.length > 0 ? (
                            showLoading ? (
                                Array?.from({ length: 6 }).map((_, index) => (
                                    <div className="col-xl-4 col-lg-4 col-md-12 mb-3" key={index}>
                                        <div className="services-card-box">
                                            <div className="services-text-box">
                                                <div className="full-name-box">
                                                    <Skeleton height={25} width={150} style={{ marginBottom: "10px" }} />
                                                    <Skeleton height={15} width={100} />
                                                </div>
                                                <div className="rating-box">
                                                    <Skeleton height={15} width={60} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                // Render the actual data when loading is false
                                allServices?.map((item, index) => (
                                    <div
                                        className="col-xl-4 col-lg-4 col-md-12 mb-3"
                                        key={index}
                                    >
                                        <div className="services-card-box">
                                            <div className="services-text-box">
                                                <div className="full-name-box">
                                                    <h1>{item.name}</h1>
                                                    <p className="card-common-text">{formattedDate}</p>
                                                </div>
                                                <div className="rating-box">
                                                    <p className="card-common-text">
                                                        {item.price}{" "}
                                                        <span>
                                                            {item.currency === "USD"
                                                                ? "$"
                                                                : item.currency === "Pound"
                                                                    ? "£"
                                                                    : item.currency === "PKR"
                                                                        ? "₨"
                                                                        : ""}
                                                        </span>
                                                    </p>
                                                </div>

                                                <div className="edit-btn-box">
                                                    <i className="fas fa-edit" onClick={() => handleEditService(item?.id)}></i>
                                                    <span>
                                                        <i data-bs-toggle="modal" onClick={() => setDeletedId(item?.id)} href="#exampleModalToggle3" role="button" className="fas fa-trash delete-icon"></i>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )
                        ) : <div className='no-data-found'>
                            <img src="/images/No-data-cuate.png" alt="" />
                        </div>}

                    </div>
                </div>
            </ProfDashboardLayout >

            <div className="modal fade" data-bs-backdrop="static" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabIndex={-1}>
                <div className="modal-dialog modal-dialog-centered service-add-model">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" id="click-close-btn" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="fa-solid fa-xmark"></i></button>
                        </div>

                        <div className="modal-body">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <form onSubmit={handleSave}>
                                            <h3 className="form-sub-heading">Employee offer services</h3>
                                            {/* <div className="add-service-box">
                                                <div className="add-service-input custom-input-box">
                                                    <select
                                                        className="add-service-control"
                                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                                        value={formData.name}
                                                    >
                                                        <option selected>Select Service</option>
                                                        {services?.map((item, index) => {
                                                            return <option value={item?.label} key={index}>{item?.label}</option>
                                                        })}
                                                    </select>
                                                </div>
                                            </div> */}

                                            <div className="professional-class-box">
                                                <Select
                                                    className="add-service-control"
                                                    options={options}
                                                    onChange={(selectedOption) =>
                                                        setFormData({ ...formData, name: selectedOption?.value })
                                                    }
                                                    value={options.find((option) => option.value === formData.name)}
                                                    isSearchable
                                                    placeholder="Select a service"
                                                />
                                            </div>

                                            <h3 className="form-sub-heading">Price for the services</h3>
                                            <div className="add-service-box">
                                                <div className="add-service-input custom-input-box">
                                                    <select
                                                        className="add-service-control"
                                                        onChange={(e) => handleCurrencyChange(e.target.value)}
                                                        value={selectedCurrency}
                                                    >
                                                        {/* <option value="" selected>Select Currency</option> */}
                                                        {currencyOptions.map((option) => (
                                                            <option key={option.label} value={option.label}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <h3 className="form-sub-heading">Price applicable for (per hour)</h3>
                                            <div className="price-service-box">
                                                <div className="add-service-input custom-input-box">
                                                    <span className="currency-symbol">
                                                        {currencyOptions.find((option) => option.label === selectedCurrency)?.symbol || "$"}
                                                    </span>

                                                    <input
                                                        type="number"
                                                        className="price-input"
                                                        onChange={(e) =>
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                price: e.target.value,
                                                            }))
                                                        }
                                                        value={formData.price}
                                                        placeholder="Enter custom price"
                                                    />
                                                </div>
                                            </div>

                                            <div className="submit-btn-form justify-content-end mb-4 mt-4">
                                                <button
                                                    type="submit"
                                                    disabled={!isFormValid || loading}
                                                    className="btn btn-primary ps-5 pe-5"
                                                >
                                                    {loading ? (
                                                        <i style={{ fontSize: "22px" }} className="fa-solid fa-spinner fa-spin"></i>
                                                    ) : "Save"}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* SECOND MODEL */}
            <div className="modal fade" data-bs-backdrop="static" id="exampleModalToggle2" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
                <div className="modal-dialog modal-dialog-centered service-add-model">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" id='close-btn-update-model' data-bs-dismiss="modal" aria-label="Close">
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <form onSubmit={handleUpdateServie}>
                                            <h3 className="form-sub-heading">Employee offer services</h3>

                                            {/* <div className="add-service-box">
                                                <div className="add-service-input custom-input-box">
                                                    <select
                                                        className="add-service-control"
                                                        onChange={(e) =>
                                                            setFormData({ ...formData, name: e.target.value })
                                                        }
                                                        value={formData.name}
                                                    >
                                                        {services?.map((item, index) => {
                                                            return <option value={item?.label} key={index}>{item?.label}</option>
                                                        })}
                                                    </select>
                                                </div>
                                            </div> */}

                                            <div className="professional-class-box">
                                                <Select
                                                    className="add-service-control"
                                                    options={options}
                                                    onChange={(selectedOption) =>
                                                        setFormData({ ...formData, name: selectedOption?.value })
                                                    }
                                                    value={options.find((option) => option.value === formData.name)}
                                                    isSearchable
                                                    placeholder="Select a service"
                                                />
                                            </div>

                                            <h3 className="form-sub-heading">Price for the services</h3>
                                            <div className="add-service-box">
                                                <div className="add-service-input custom-input-box">
                                                    <select
                                                        className="add-service-control"
                                                        onChange={(e) => handleCurrencyChange(e.target.value)}
                                                        value={formData.currency}
                                                    >
                                                        {currencyOptions.map((option) => (
                                                            <option key={option.label} value={option.label}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>

                                            <h3 className="form-sub-heading">Price applicable for (per hour)</h3>
                                            <div className="price-service-box">
                                                <div className="add-service-input custom-input-box">
                                                    <span className="currency-symbol">
                                                        {currencyOptions.find((option) => option.label === formData.currency)?.symbol || "$"}
                                                    </span>

                                                    <input
                                                        type="number"
                                                        className="price-input"
                                                        onChange={(e) => setFormData((prev) => ({ ...prev, price: e.target.value }))}
                                                        value={formData.price}
                                                        placeholder="Enter custom price"
                                                    />
                                                </div>
                                            </div>

                                            <div className="submit-btn-form justify-content-end mb-4 mt-4">
                                                <button type="submit" className="btn btn-primary">
                                                    {loading || showLoading ? (
                                                        <i style={{ fontSize: "22px" }} className="fa-solid fa-spinner fa-spin"></i>
                                                    ) : "Update"}
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* SECOND MODEL */}

            {/* THIRD MODEL */}
            <div className="modal fade" data-bs-backdrop="static" id="exampleModalToggle3" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabindex="-1">
                <div className="modal-dialog modal-dialog-centered service-add-model">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" id='close-btn-update-model-3' data-bs-dismiss="modal" aria-label="Close">
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12 mt-4">
                                        <div className="full-name-box justify-content-center">
                                            <h1>Are your sure you want to delete service?</h1>
                                        </div>
                                        <div className="justify-content-center d-flex mb-4 mt-4">
                                            <button type="button" className="btn btn-danger me-2" onClick={() => handleDeleteService(deletedId)}>
                                                {deleteLoading || showLoading ? (
                                                    <i style={{ fontSize: "22px" }} className="fa-solid fa-spinner fa-spin"></i>
                                                ) : "Delete"}
                                            </button>

                                            <button type="button" id='close-btn-update-model-3' data-bs-dismiss="modal" aria-label="Close" className="btn btn-secondary">
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* THIRD MODEL */}
        </>
    )
}

export default ProfMyServices